/**
 * PrivacyPolicyPage
 *
 * Static public page displaying the Privacy Policy.
 * Accessible without authentication.
 */
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { LegalDocumentPage } from './LegalDocumentPage';
import privacyPolicyHtml from './content/privacyPolicy.html?raw';

export const PrivacyPolicyPage = () => {
  const { l10n } = useLocale();
  return <LegalDocumentPage qaId="legal-privacy-policy" title={l10n.legal.privacyPolicy} htmlContent={privacyPolicyHtml} />;
};
